export default {
    STC: 5,
    PTC: 10,
    DVCQ: 15,
    School: 20,
    Department: 25,
    Ward: 30,
    District: 35,
}